(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    $(document.body).on("click", ".see-more--exported-products", function (event) {
      var list = document.getElementsByClassName("more-exported-products");
      event.currentTarget.style.display = "none";
      for (i = 0; i < list.length; i++) {
        list[i].style.display = "flex";
      }
    });
  });
})(jQuery);